import { kebabCase } from 'lodash';

import { RadialChartData } from '@/types';

export const getEmissionsRadialChartConfig = (data: RadialChartData[]) => {
  return data.reduce(
    (acc, item) => ({
      ...acc,
      [kebabCase(item.name)]: {
        color: item.color,
        label: item.name,
      },
    }),
    {},
  );
};

export const getEmissionsRadialChartData = (data: RadialChartData[]) => {
  return data.map((item) => {
    return {
      ...item,
      // Use the colour defined in the chart config
      fill: `var(--color-${kebabCase(item.name)})`,
    };
  });
};
